import AppLoader from '../Loader';

export const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <AppLoader.FlexLoader className="items-center" />
  </div>
);
